module.exports = __webpack_public_path__ + "static/media/avatar.fc047347.png";